export { default } from "./CurricUnitDetailsAccordion";
